export const ACCOUNT_SETTINGS_TAB_KEY = "account-settings-tab";

export const ACCOUNT_SETTINGS_TABS = [
  "profile",
  "personal",
  "my-account",
  "change-password",
  "tanks",
  "pair-devices",
  "settings",
];

export function isValidAccountSettingsTab(value) {
  return ACCOUNT_SETTINGS_TABS.includes(value);
}
